export const sexualOrientation = {
  HOMOSEXUAL: { value: 1, label: 'homosexual' },
  BISEXUAL: { value: 2, label: 'bisexual' },
  TRANSGENDER: { value: 3, label: 'transgender' },
  INTERSEX: { value: 4, label: 'intersex' },
  HETEROSEXUAL: { value: 5, label: 'heterosexual' },
};
